import { questoes } from '@/services/questoes'
import { tipoQuestao } from '@/services/tipoQuestao'

export default {

	async unloadTypes (context, payload) {
		context.commit('UNLOAD_CURATION_TYPES', { data: [] })
		context.commit('UNLOAD_OBJECT_TYPES', { data: [] })
	},

	async unloadObjectTypes (context, payload) {
		context.commit('UNLOAD_OBJECT_TYPES', { data: [] })
	},

	async loadAllTypesQuestions (context) {
		const res = await questoes.tipoQuestao()
		const all = res.data.map(d => {
			return {
				...d,
				tipoQuestaoId: d.id,
				qtd: 10,
				dirty: false,
				type: 'db'
			}
		})
		context.commit('LOAD_ALL_TYPES', { data: all })
	},

	async loadObjectTypesQuestions (context, payload) {
		let tipos = await tipoQuestao.obterInfoQuestaoObjeto(payload)
		tipos = tipos.data.map(t => {
			return { ...t, type: 'object', dirty: false }
		})
		context.commit('LOAD_OBJECT_TYPES', { data: tipos })
	},

	async loadObjectTypesCuradoria (context, payload) {
		let tipos = await tipoQuestao.obterInfoQuestaoCuradoria(payload)
		tipos = tipos.data.map(t => {
			return { ...t, type: 'curation', dirty: false }
		})
		context.commit('LOAD_CURATION_TYPES', { data: tipos })
	},
	updateQtdQuestions (context, payload) {
		payload.index = context.state[payload.type].findIndex(t => t.tipoQuestaoId === payload.tipoQuestaoId)
		context.commit('UPDATE_QTD_OBJECT_TYPES', payload)
	}
}
